import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=d34c0b52&"
import script from "./ChatContact.vue?vue&type=script&lang=js&"
export * from "./ChatContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports